import React from "react";
import clsx from "clsx";
import LocksCard from "../../LocksCard/LocksCard";

class RoomBuilderHousekeepingGeneral extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    //console.log("RoomBuilderHousekeepingGeneral", this.props);

    var tabClasses = clsx({
      active: this.props.active_tab == "housekeeping-general",
      "tab-pane": true,
    });

    return (
      <div className={`${tabClasses} root`} id="housekeeping-general">
        <div className="row">
          <div className="col">
            <div className="row first">
              <div className="col-sm-6">
                <label>{`${I18n.t("room_identifier")}`}</label>{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("identifier_helper_text")}
                ></span>
                <div style={{ padding: 0 }}>
                  {this.props.housekeeping_room
                    ? this.props.housekeeping_room.identifier
                    : null}
                </div>
              </div>
              <div className="col-sm-6">
                <label>{I18n.t("room_type")}</label>
                <br />
                <div style={{ padding: 0 }}>
                  {this.props.housekeeping_room_type
                    ? this.props.housekeeping_room_type.name
                    : null}
                </div>
              </div>
            </div>
            <br />
            <div className="row last">
              <div className="col-sm-6">
                <label>
                  {I18n.t("housekeeping_status")}{" "}
                  <span
                    className="ss-help help"
                    title={I18n.t("housekeeping_status_helper_text")}
                  ></span>
                </label>
                <select
                  className="form-control"
                  value={this.props.status}
                  name="status"
                  onChange={this.props.onChange}
                >
                  <option value="dirty">{I18n.t("dirty")}</option>
                  <option value="clean">{I18n.t("clean")}</option>
                </select>
              </div>
              <div className="col-sm-6">
                <label>
                  {I18n.t("occupancy_status")}{" "}
                  <span
                    className="ss-help help"
                    title={I18n.t("occupancy_status_helper_text")}
                  ></span>
                </label>
                <select
                  className="form-control"
                  value={this.props.occupancy_status}
                  name="occupancy_status"
                  onChange={this.props.onChangeOccupancyStatus}
                >
                  <option value="none">{I18n.t("none")}</option>
                  <option value="occupied">{I18n.t("occupied")}</option>
                  <option value="vacant">{I18n.t("vacant")}</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col">
            <LocksCard
              room={this.props.housekeeping_room}
              panelStyle={{ margin: "0px" }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default RoomBuilderHousekeepingGeneral;
